module.exports = __webpack_public_path__ + "static/media/image1.18a189f9.jpg";